import { defineComponent as _defineComponent } from 'vue'
import { buryPoint } from '@/apis/common/buryPoint'
import { reactive, ref, watch } from 'vue'

import CodeInput from '../components/codeInput.vue'
import FormItem from '../components/formItem.vue'
import inputTableVue from '../components/inputTable.vue'
import { Knif } from '../util/types'
import {
  codeList,
  holeSetting,
  knivesColumns,
  lmlSetting,
  mtSetting,
  slotSetting,
} from './customFourthConf'


export default /*#__PURE__*/_defineComponent({
  __name: 'customFourth',
  props: {
    data: null
  },
  emits: ['onDataChange'],
  setup(__props: any, { emit }) {

const props = __props as { data: any }

const otherSettingMap = new Map([
  ['拉米诺', 'lmlSetting'],
  ['榫卯', 'mtSetting'],
])





const formData = reactive<{ [key: string]: any }>({
  beginCode: '',
  pauseCode: '',
  collectKnifeCode: '',
  endCode: '',
  leftTurnCode: '',
  leftTurnEndCode: '',
  backTurnCode: '',
  backTurnEndCode: '',
  rightTurnCode: '',
  rightTurnEndCode: '',
  frontTurnCode: '',
  frontTurnEndCode: '',
  slotEnable: false,
  slotKnife: '',
  slotCutCode: '',
  holeEnable: false,
  holeKnife: '',
  holeCutCode: '',
  lmlSetting: {
    lmlCutCode: '',
    lmlEnable: false,
    lmlKnife: 'T1',
  },
  YMSetting: {
    knife: '',
    cutCode: {
      headerIds: {},
      templateString: '',
    },
  },
  mtSetting: {
    mtArcCutCode: '',
    mtArcInterpolation: false,
    mtEnable: true,
    mtLineCutCode: '',
  },
  use_win_line_feed: true,
  file_encode: 'utf-8',
  fileSuffix: '',
  xPointSymbol: '',
  yPointSymbol: '',
  zPointSymbol: '',
  knives: [],
})

const currentSpecialSetting = ref('拉米诺')

const tableData = ref<Knif[]>([])

const knivesOption = ref<string[]>([])

function handleChangeSpecial(item: string) {
  currentSpecialSetting.value = item
}

watch(
  () => props.data,
  (val) => {
    if (val) {
      for (const key in formData) {
        formData[key] = val.settingV4[key]
      }

      tableData.value = formData.knives
      if (formData?.use_win_line_feed == undefined) {
        formData.use_win_line_feed = true
      }
      if (formData?.file_encode == undefined) {
        formData.file_encode = 'utf-8'
      }
    }
  },
  {
    immediate: true,
  }
)
// 表单数据传出
watch(
  () => formData,
  (val) => {
    emit('onDataChange', val)
  },
  {
    deep: true,
  }
)

// 刀具库数据处理
watch(
  () => tableData.value,
  (val) => {
    formData.knives = val
    knivesOption.value = val.map((knif) => knif.knifeName)
  },
  {
    immediate: true,
    deep: true,
  }
)

return { __sfc: true,otherSettingMap, props, emit, formData, currentSpecialSetting, tableData, knivesOption, handleChangeSpecial, buryPoint, CodeInput, FormItem, inputTableVue, codeList, holeSetting, knivesColumns, lmlSetting, mtSetting, slotSetting }
}

})